import { Keyhole, SlidersHorizontal, UserCircle } from '@phosphor-icons/react'

import { providers } from '@/returns/constants'
import routes from '@/Router/routes.constants'

import { tabIds } from './constants'

export const getTabs = (t, provider) =>
  [
    {
      id: tabIds.profile,
      label: t('Perfil'),
      Icon: UserCircle,
      path: routes.accountPage.profile,
    },
    {
      id: tabIds.branding,
      label: t('Seguridad'),
      Icon: Keyhole,
      path: routes.accountPage.security,
    },
    {
      id: tabIds.preferences,
      label: t('Preferencias'),
      Icon: SlidersHorizontal,
      path: routes.accountPage.preferences,
      visible: [providers.shopify, providers.bigcommerce, providers.centra].includes(provider),
    },
  ].filter(tab => tab.visible !== false)
